import React, { useState, useEffect, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from "react-i18next";
import { Button} from '@mui/material';

const DigitalClock = ({ time }) => (
  <div style={{
    fontFamily: '"Digital-7 Mono", sans-serif',
    fontSize: '20px',
    color: '#0d6efd', // Azul Bootstrap por ejemplo
    textAlign: 'center',
    margin: '10px 0'
  }}>
    {time}
  </div>
);

const CountdownTimerDialog = ({ open, setOpen, timestampStart, isAdmin }) => {
  const { t } = useTranslation("global");
  const [timeLeft, setTimeLeft] = useState("");
  const [currentTime, setCurrentTime] = useState(new Date());
  const counter = useRef(0)
  let timer = null

  useEffect(() => {
    
    if (open){
      timer = setInterval(() => {
        const now = new Date();
        setCurrentTime(now)
        const targetDate = new Date(timestampStart);
        const difference = targetDate - now;
  
  
        counter.current = counter.current+1
        // console.log("🚀 ~ file: CountdownTimerDialog.js:47 ~ timer ~ counter.current:", counter.current)
        if (isAdmin && counter.current>10){
          clearInterval(timer);
          setTimeLeft("El tiempo ha terminado");
          setOpen(false)
        }
  
        if (difference > 0) {
          const days = Math.floor(difference / (1000 * 60 * 60 * 24));
          const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((difference / 1000 / 60) % 60);
          const seconds = Math.floor((difference / 1000) % 60);
  
          setTimeLeft(`${days} días, ${hours} horas, ${minutes} minutos, ${seconds} segundos`);
        } else {
          clearInterval(timer);
          setTimeLeft("El tiempo ha terminado");
        }
  
        
  
      }, 1000);


    }else{
      clearInterval(timer);
      counter.current = 0
    }

    return () => clearInterval(timer);
  }, [open]);

  


  return (
    <Dialog open={open} onClose={() => setOpen(false)} style={{ textAlign: 'center' }}>
      <DialogTitle className="sig_Drawer_SettingsModal_Title sig_Main_TitleWithIcon" >  {t("sCountdownTimerDialog.title")} </DialogTitle>
      <DialogContent style={{ width: '500px', margin: '20px' }}>
        <DialogContentText>
          <strong> {t("sCountdownTimerDialog.currentTime")} </strong> {currentTime.toLocaleString()} <br />
          <strong> {t("sCountdownTimerDialog.timestampStart")} </strong> {new Date(timestampStart).toLocaleString()} <br /><br />
          <strong> {t("sCountdownTimerDialog.timeLeft")} </strong>
          <DigitalClock time={timeLeft} />
          
          <div style={{margin:'auto', width:'80%', padding: '12px', backgroundColor: '#5ea0d4', border: '1px solid #5ea0d4', borderRadius: '5px', fontSize: '14px'}}>
          <p> {t("sCountdownTimerDialog.body1")} </p> 
          <p><strong> {t("sCountdownTimerDialog.body2")} </strong></p>
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default CountdownTimerDialog;